module.exports = __webpack_public_path__ + "static/media/tighter.51406a75.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/tighter.mp3
// module id = 522
// module chunks = 0